import { render, staticRenderFns } from "./platcontract.vue?vue&type=template&id=4fcd64ae&scoped=true&"
import script from "./platcontract.vue?vue&type=script&lang=js&"
export * from "./platcontract.vue?vue&type=script&lang=js&"
import style0 from "./platcontract.vue?vue&type=style&index=0&id=4fcd64ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd64ae",
  null
  
)

export default component.exports